import React, { useEffect, useRef, useState, } from 'react';
import { isMobile } from 'react-device-detect';
import { FormFieldKind } from '../FormFieldGroup';
import { classNames } from '../../utils/helpers';
import styles from '../FormFieldGroup/FormField.module.scss';
const Dropdown = ({ id, name = id, label, value, values, help, kind = FormFieldKind.Default, required = false, disabled = false, skipValidation = false, onChange = () => undefined, onValidChange = () => undefined, onAdditionalValidation = () => undefined, }) => {
    const [internalValue, setInternalValue] = useState();
    const [internalValueLabel, setInternalValueLabel] = useState('');
    const [internalValues, setInternalValues] = useState([]);
    const [internalError, setInternalError] = useState('');
    const [internalKind, setInternalKind] = useState(FormFieldKind.Default);
    const [isDirty, setDirty] = useState(false);
    const [isActive, setActive] = useState(false);
    const [activeOptionIndex, setActiveOptionIndex] = useState(null);
    const inputRef = useRef(null);
    const handleInternalValueChange = () => {
        var _a, _b, _c;
        if (!isMobile) {
            setInternalValueLabel((_b = (_a = values === null || values === void 0 ? void 0 : values.find((item) => item.value === internalValue)) === null || _a === void 0 ? void 0 : _a.valueLabel) !== null && _b !== void 0 ? _b : '');
            setActiveOptionIndex(null);
            (_c = inputRef.current) === null || _c === void 0 ? void 0 : _c.blur();
        }
        if (internalValue !== undefined && value !== internalValue) {
            onChange(id, internalValue);
        }
    };
    useEffect(() => handleInternalValueChange(), [internalValue]);
    useEffect(() => {
        const tmpValues = values !== null && values !== void 0 ? values : [];
        setInternalValues(tmpValues);
        if (!tmpValues.length) {
            setInternalValue('');
        }
    }, [values, internalValue]);
    useEffect(() => {
        let nextKind = kind;
        if (!skipValidation && !disabled && isDirty) {
            if (isActive && !internalError) {
                nextKind = FormFieldKind.Approved;
            }
            else if (!isActive && !!internalError) {
                nextKind = FormFieldKind.Error;
            }
        }
        setInternalKind(nextKind);
    }, [skipValidation, disabled, isDirty, isActive, internalError]);
    useEffect(() => setInternalKind(kind), [kind]);
    const test = (targetValue = '', dirty = true) => {
        let errorMessage;
        if (!skipValidation) {
            if (required && targetValue === '') {
                errorMessage = required.toString();
            }
            else {
                errorMessage = onAdditionalValidation(targetValue, !errorMessage, id);
            }
        }
        setInternalError(errorMessage || '');
        setDirty(dirty);
        onValidChange(id, !errorMessage);
    };
    const validateThenSetInternalValue = (newValue = '') => {
        if (newValue !== internalValue) {
            const index = values === null || values === void 0 ? void 0 : values.findIndex((item) => item.value === newValue);
            setInternalValue(index !== undefined && index >= 0 ? newValue : '');
        }
    };
    useEffect(() => {
        test(value, false);
        validateThenSetInternalValue(value);
    }, [value]);
    const handleOptionChange = (item) => {
        test(item === null || item === void 0 ? void 0 : item.value, true);
        validateThenSetInternalValue(item === null || item === void 0 ? void 0 : item.value);
    };
    const handleSelectChange = (e) => {
        e.preventDefault();
        test(e.target.value, true);
        validateThenSetInternalValue(e.target.value);
    };
    const handleFocusGain = (e) => {
        e.preventDefault();
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.selectionEnd = 0;
        }
        setActive(true);
        setDirty(true);
    };
    const handleFocusLost = (e) => {
        e.preventDefault();
        setActive(false);
        test(internalValue, true);
    };
    const handleOptionSelect = (e) => {
        var _a;
        const maxIndex = (values && values.length - 1) || 0;
        let newIndex = activeOptionIndex;
        if (e.key === 'ArrowUp') {
            if (activeOptionIndex !== null && activeOptionIndex > 0) {
                newIndex = activeOptionIndex - 1;
            }
            else {
                newIndex = maxIndex;
            }
        }
        else if (e.key === 'ArrowDown') {
            if (activeOptionIndex !== null && activeOptionIndex < maxIndex) {
                newIndex = activeOptionIndex + 1;
            }
            else {
                newIndex = 0;
            }
        }
        else if (e.key === 'Enter') {
            handleOptionChange((_a = internalValues[newIndex]) !== null && _a !== void 0 ? _a : null);
            handleInternalValueChange();
        }
        setActiveOptionIndex(newIndex);
    };
    const handleInvalid = (e) => {
        e.preventDefault();
        if (!disabled) {
            setDirty(true);
        }
    };
    const commonProps = {
        id,
        name,
        disabled,
        required: !!required,
        autoComplete: 'off',
        onFocus: handleFocusGain,
        onBlur: handleFocusLost,
        onInvalid: handleInvalid,
    };
    const isError = () => internalKind === FormFieldKind.Error && !!internalError;
    return (React.createElement("div", { className: classNames(styles.formFieldContainer, isActive && styles.active) },
        React.createElement("div", { className: classNames(styles.formField, styles.dropdown) },
            React.createElement("div", { className: styles.formFieldLabelWrapper },
                React.createElement("label", { htmlFor: id, className: classNames(!!internalValue && styles.collapsed, disabled && styles.disabled, internalKind === FormFieldKind.Error && styles.error) }, label),
                React.createElement("div", { className: classNames(styles.fade, disabled && styles.disabled, internalKind === FormFieldKind.Error && styles.error, styles.dropdown) })),
            isMobile ? (React.createElement("select", { value: internalValue !== null && internalValue !== void 0 ? internalValue : '', onChange: handleSelectChange, className: styles[internalKind], ...commonProps }, !!(values === null || values === void 0 ? void 0 : values.length) &&
                [{ key: '', value: '', valueLabel: '' }, ...values].map((item) => (React.createElement("option", { key: item.key, value: item.value }, item.valueLabel))))) : (React.createElement(React.Fragment, null,
                React.createElement("input", { ref: inputRef, type: "text", value: internalValueLabel !== null && internalValueLabel !== void 0 ? internalValueLabel : '', onKeyUp: handleOptionSelect, onChange: () => undefined, className: classNames(styles.dropdown, styles[internalKind]), ...commonProps }),
                internalValue ? (React.createElement("button", { type: "button", className: styles.clear, onClick: (e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleOptionChange();
                    } })) : null))),
        !isMobile && isActive && (React.createElement("div", { className: styles.optionsList }, internalValues.map((item, index) => (React.createElement("div", { key: item.key, className: classNames(styles.optionItem, index === activeOptionIndex && styles.active), onMouseDown: (e) => {
                e.stopPropagation();
                handleOptionChange(item);
            }, onMouseEnter: () => setActiveOptionIndex(index), onMouseLeave: () => setActiveOptionIndex(null), "aria-hidden": true }, item.valueLabel))))),
        (isError() || help) && (React.createElement("div", { className: classNames(styles.formFieldHelp, styles[internalKind]), "data-testid": `test-${id}-${internalKind}-message` }, isError() ? internalError : help))));
};
export default Dropdown;
